// Filters interfaces
export interface FilterItem {
	key: string;
	label: string;
	active: boolean;
	show: boolean;
}

export class AdditionalButtons extends Array<AdditionalButton> {}

export class AdditionalButton {
	public label: string;
	public href: string;
}

export interface TopPanelConfig {
	title: {
		key: string;
		label: string;
	};

	filters: {
		dateFilter: {
			key: string;
			label: string;
		};

		azFilter: {
			key: string;
			label: string;
		};
	};

	icon: {
		key: string;
		icon: string;
	};

	filterText: {
		key: string;
		label: string;
	};

	button: {
		key: string;
		label: string;
		href: string;
	};
}
